import React from 'react';
import '../i18n/config';
import "./HeaderFooter.css";
import "./BeforeLogin.css";
import {Footer} from "./Dashboard/Footer";

type BeforeLoginProps = {
    onLoginClick: () => void
}

export const BeforeLogin = (props: BeforeLoginProps) => {
    return (
        <div>
            <div className="header">
            </div>
            <div className="before-login-main">
                <div className="before-login-sign-in">
                    <div>
                        <h3>JourneyCycleにサインインする</h3>
                        <p>
                            JourneyCycleをご利用いただくには、Googleアカウントを使ってサインインしてください。<br/>
                            サインインする場合、<a href="https://jourcy.com/terms.html">利用規約</a>、<a
                            href="https://jourcy.com/privacy-policy.html">プライバシーポリシー</a>に同意したものとみなします。
                        </p>
                        <div className="sign-in-with-google" onClick={() => props.onLoginClick()}/>
                    </div>
                </div>
            </div>
            <Footer/>

        </div>
    );
}
